import { combineReducers } from 'redux';
import moment from 'moment';

const dailyMessages = (state = [], action) => {
  switch (action.type) {
    case 'SET_DAILYMESSAGE':
      return action.messages;
    default:
      return state;
  }
};

const dailyMessagesLoaded = (state = false, action) => {
  switch (action.type) {
    case 'SET_DAILYMESSAGE':
      return moment();
    default:
      return state;
  }
};

export default combineReducers({
  dailyMessages,
  dailyMessagesLoaded,
});

export const getMessages = (state) => state.dailyMessages;
export const getMessagesLoaded = (state) => {
  return state.dailyMessagesLoaded && state.dailyMessagesLoaded.format('YYYYMMDD') === moment().format('YYYYMMDD');
};
